<template>
  <el-dialog class="record-add" title="新增联系人" top="5%" width="130rem" :modal-append-to-body="false"
    :visible.sync="showContact" @open="open" @close="close">
    <el-form :inline="true"  v-if="showContact" :model="contact" ref="ruleForm" label-width="140px" label-position="right" :rules="rules">
      <el-form-item label="姓名" prop="name">
        <el-input v-model="contact.name" placeholder="请输入姓名" style="width: 220px" clearable></el-input>
      </el-form-item>
      <el-form-item label="手机" required>
        <template v-for="(i, idx) of contact.mobile">
          <div class="phone-line" :key="idx">
            <el-input v-model="contact.mobile[idx].tel" placeholder="请输入手机" style="width: 330px !important;margin-right:20px"
              @blur="onCheckTel(contact.mobile[idx])" clearable></el-input>
              <div class="btn-box">
            <el-button class="add-btn" :disabled="nolength" icon="el-icon-minus"
              @click="delPhone(contact.mobile, idx)"></el-button>
              <span></span>
              <!-- v-if="idx == contact.mobile.length - 1" -->
            <el-button class="add-btn" icon="el-icon-plus"
              @click="addPhone(contact.mobile)"></el-button>
            </div>
            <p v-if="contact.mobile[idx].code == 99" style="color: #f56c6c; margin-left: 20px">
              <i class="el-icon-error" style="margin-right: 4px"></i>
              <span>{{ contact.mobile[idx].errorMsg }}</span>
            </p>
            <p v-if="contact.mobile[idx].code == 1" style="color: #67c23a; margin-left: 20px">
              <i class="el-icon-success" style="margin-right: 4px"></i>
              <span>{{ contact.mobile[idx].errorMsg }}</span>
            </p>
          </div>
        </template>
      </el-form-item>
      <el-form-item label="固定电话" prop="telephone">
        <el-input v-model="contact.telephone" placeholder="请输入固定电话" style="width: 220px" clearable></el-input>
      </el-form-item>
      <el-form-item label="邮箱">
        <el-input v-model="contact.email" placeholder="请输入邮箱" style="width: 220px" clearable></el-input>
      </el-form-item>
      <el-form-item label="关键决策人">
        <el-select v-model="contact.decision" placeholder="请选择是否为关键决策人">
          <el-option v-for="item in decisionOption" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="性别">
        <el-select v-model="contact.sex" placeholder="请选择性别">
          <el-option v-for="item in sexOption" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="职位">
        <el-input v-model="contact.post" placeholder="请输入职位" style="width: 220px" clearable></el-input>
      </el-form-item>
      <el-form-item label="地址">
        <el-cascader v-model="contact.address" :options="area" placeholder="请选择地址" clearable></el-cascader>
      </el-form-item>
      <el-form-item label="详细地址">
        <el-input v-model="contact.detail_address" placeholder="请输入详细地址" clearable></el-input>
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="contact.remark" placeholder="请输入备注" clearable></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" :loading="lockSave" @click="formSubmit">保存</el-button>
      <el-button type="primary" class="btn-big" :loading="lockAdd" @click="addContact">继续添加联系人</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { addContacts } from "@/api/common";
import { regionData, CodeToText } from "element-china-area-data";
import { rules } from "@/mixins/rule.js";
import { checkPhone } from "@/api/common";
export default {
  name: "addContact",
  inject: ["reload"],
  mixins: [rules],
  props: {
    id: Number,
    userid: {
      type: String,
      required: false, //如果传值使用当前负责人（线索、客户详情内）， 如果不传值则使用当前用户（如新增线索，新增客户时添加相关联系人）
    },
    type: String,
  },

  data() {
    return {
      rules: {
        mobile: [
          {
            required: false,
            pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
            message: "手机号码有误，请重填",
            trigger: "blur",
          },
        ],
      },
      showContact: false,
      area: regionData,
      contact: {
        name: "",
        mobile: [
          {
            tel: "",
            errorMsg: "",
            code: 0,
          },
        ],
        telephone: "",
        email: "",
        decision: 0,
        post: "",
        sex: 1,
        address: "",
        detail_address: "",
        remark: "",
      },
      sexOption: [
        {
          value: 1,
          label: "男",
        },
        {
          value: 2,
          label: "女",
        },
      ],
      decisionOption: [
        {
          id: 1,
          name: "是",
        },
        {
          id: 0,
          name: "否",
        },
      ],
      btn: "submit",
      lockSave: false,
      lockAdd: false,
    };
  },
  computed:{
    nolength() {
      // let i
      // this.forms?.map((item, index) => {
      //   if (item.label === '联系电话') {
      //     i = index
      //   }
      // })
      let a
      if(this.contact.mobile.length==1){
        a = true
      }
      return a;
    }
  },
  methods: {
    async onCheckTel(obj) {
      try {
        const res = await checkPhone({
          account_id: this.$store.state.user.token.account_id,
          remark_mobiles: obj.tel,
        });
        obj.errorMsg = res.msg;
        obj.code = res.code;
      } catch (error) {
        console.log(error);
      }
    },
    async onSaveContact() {
      if (this.contact.address) {
        const province = CodeToText[this.contact.address[0]];
        const city = CodeToText[this.contact.address[1]];
        const area = CodeToText[this.contact.address[2]];
        this.contact.address = `${province},${city},${area}`;
      }
      const contactMobiles = this.contact.mobile;
      let mobile = [];

      // 手机号验证
      let flag = false;
      for (let i = 0; i < contactMobiles.length; i++) {
        const item = contactMobiles[i];
        if (item.code == 99) {
          // 验证不通过
          this.$message({
            type: "error",
            message: item.errorMsg,
          });
          flag = true;
          return;
        }

        if (!item.tel) {
          // 空手机号
          const errorMsg = "手机号不能为空";
          this.$message({
            type: "error",
            message: errorMsg,
          });
          item.code = 99;
          item.errorMsg = errorMsg;
          flag = true;
          return;
        }

        mobile.push(item.tel);
      }
      if (flag) {
        return;
      }

      const contact = {
        account_id: this.$store.state.user.token.account_id,
        userid: this.userid ?? this.$store.state.user.token.userid,
        name: this.contact.name,
        mobile: mobile,
        telephone: this.contact.telephone,
        email: this.contact.email,
        decision: this.contact.decision,
        post: this.contact.position,
        sex: this.contact.gender,
        address: this.contact.address,
        detail_address: this.detail_address,
        remark: this.contact.remark,
      };
      if (this.type === "leads") {
        Object.assign(contact, {
          leads_id: this.id,
        });
      }
      if (this.type === "customer") {
        Object.assign(contact, {
          customer_id: this.id,
        });
      }
      if (this.btn === "submit") {
        this.lockSave = true;
      } else {
        this.lockAdd = true;
      }
      const res = await addContacts(contact);
      if (res.code == 1) {
        this.$message({
          message: "添加成功",
          type: "success",
        });
        this.initData();
        if (this.btn === "submit") {
          if (this.$route.name === "customer" || this.$route.name === "clues") {
            this.reload();
            return;
          }
          this.close();
          this.$emit("handleSubmit");
        } else {
          this.$emit("handleSubmit");
          this.initData();
        }
      }
      this.lockSave = false;
      this.lockAdd = false;

    },
    formSubmit() {
      this.btn = "submit";
      this.submitForm();
    },
    addContact() {
      this.btn = "add";
      this.submitForm();
      // this.initData();
      // for (let i = 0; i < this.contact.mobile.length; i++) {
      //   this.contact.mobile[i].tel = ''
      // }
      // this.contact.mobile.length = 1

    },
    addPhone(item) {
      item.push({
        tel: "",
        errorMsg: "",
        code: 0,
      });
    },
    delPhone(arr, index) {
      if (arr.length === 1) {
        arr[0] = {
          tel: "",
          errorMsg: "",
          code: 0,
        };
        arr.push();
        return;
      }
      arr.splice(index, 1);
    },
    open() {
      this.initData();
      this.showContact = true;
    },
    close() {
      this.showContact = false;
    },
    submitForm() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.onSaveContact();
          return true;
        } else {
          return false;
        }
      });
    },
    initData() {
      this.contact = {
        name: "",
        mobile: [
          {
            tel: "",
            errorMsg: "",
            code: 0,
          },
        ],
        telephone: "",
        email: "",
        decision: 0,
        post: "",
        sex: 1,
        address: "",
        detail_address: "",
        remark: "",
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.submit {
  margin-top: 50px;
  display: flex;
  justify-content: center;
}

.phone-line {
  margin-top: 0;
  display: flex;
}



.add-btn {
  border: 0;
  width: 50% !important;
  height: 100%;
  margin :0;
  background: none;
  :hover{
    background: none;
  }
}
::v-deep .el-form{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .el-form-item{
    width: 50%;
    margin-bottom: 30px;
  }
  .el-input{
    width: auto;
  }
}
.btn-box {
  border-radius: 20px;
  width: 100px;
  border: 0px;
  height: 100%;
  border: 1px solid #e6e6e6;
  display: flex;
  align-items: center;
  span{
    height: 25px;
    background: #e6e6e6;
    width: 1px;
  }
}

::v-deep .el-form--inline .el-form-item{
  width:50%;
  margin-right: 0px;
  margin-bottom: 30px;
}
::v-deep .el-form--inline  .el-input{
  width:470px !important;
}
.btn-box{
  border-radius: 20px;
  width: 100px;
  border: 0px ;
  height: 100%;
  border: 1px solid #e6e6e6;
  display: flex;
  align-items: center;

}
.btn-box>span{
    height: 25px;
    background: #e6e6e6;
    width: 1px;
}
.add-btn {
  margin-left: 0px;
  margin-right:0px;
  height: 100%;
  width: 50% !important;
  border: none;
  background: none;
}
</style>
